(() => {
  if (window.wncKitShippingBound) return;
  window.wncKitShippingBound = true;
  const attach = async kit => {
    if (!kit) return;
    await customElements.whenDefined('wnc-shipping-calculator');
    if (!kit.isConnected) return;
    const shipping = kit.querySelector('wnc-shipping-calculator');
    if (!shipping?.active || shipping.wncKitBridge) return;
    shipping.wncKitBridge = true;
    const originalRequest = shipping.request.bind(shipping);
    shipping.selection = () => {
      const selected = kit.selection;
      if (!selected?.ready || !selected.items.length) return null;
      const first = shipping.variants.get(String(selected.items[0].id));
      return first ? { variant: first, quantity: selected.quantity } : null;
    };
    const originalPromotion = shipping.renderPromotion.bind(shipping);
    const projectedSubtotal = () => {
      const cart = shipping.cart || {};
      const selected = kit.selection;
      const cartTotal = Math.max(0, Number(cart.total_price) || 0);
      if (!selected?.ready) return cartTotal;
      const originalTotal = cart.original_total_price;
      if (!Number.isFinite(originalTotal) || originalTotal < 0) return null;
      const applications = [
        ...(cart.cart_level_discount_applications || []),
        ...(cart.discount_codes || []),
        ...(cart.items || []).flatMap(item => [...(item.discounts || []), ...(item.discount_allocations || []).map(allocation => allocation.discount_application)])
      ].filter(Boolean);
      const knownCodes = new Set(kit.tiers.map(tier => tier.discountCode).filter(Boolean));
      const hasDiscount = cartTotal < originalTotal || Number(cart.total_discount) > 0 || applications.length > 0;
      if (applications.some(application => !knownCodes.has(application.code || application.title)) || hasDiscount && !applications.length) return null;
      const variantIds = new Set(kit.variants.map(variant => String(variant.id)));
      const cartQuantity = (cart.items || []).reduce((sum, item) => sum + (variantIds.has(String(item.variant_id ?? item.id)) ? Math.max(0, Number(item.quantity) || 0) : 0), 0);
      const finalQuantity = cartQuantity + selected.quantity;
      const tier = kit.config.pricingEnabled && kit.tiers.filter(item => item.discountCode && Number(item.quantity) > 0 && Number(item.quantity) <= finalQuantity).reduce((best, item) => !best || Number(item.quantity) > Number(best.quantity) ? item : best, null);
      if (tier) {
        const tierTotal = Number(tier.totalCents ?? tier.total);
        const baseUnit = Number(kit.config.baseUnitCents);
        if (!Number.isFinite(tierTotal) || tierTotal < 0 || !Number.isFinite(baseUnit) || baseUnit <= 0 || !Number.isFinite(selected.baseTotal)) return null;
        const discountPerPiece = Math.max(0, baseUnit - tierTotal / Number(tier.quantity));
        return Math.max(0, Math.round(originalTotal + selected.baseTotal - discountPerPiece * finalQuantity));
      }
      return hasDiscount ? null : Math.max(0, cartTotal + selected.totalCents);
    };
    shipping.subtotal = () => projectedSubtotal() ?? 0;
    shipping.renderPromotion = () => {
      originalPromotion();
      if (projectedSubtotal() !== null) return;
      const text = shipping.querySelector('[data-promotion-text]');
      const progress = shipping.querySelector('[data-progress]');
      if (text) text.textContent = shipping.strings.rule;
      if (progress) progress.hidden = true;
    };
    shipping.request = (path, payload, controller) => {
      if (path === '/api/shipping/quote') {
        const selected = kit.selection;
        if (!selected?.ready) return Promise.reject(new Error('incomplete_selection'));
        const discountPerPiece = selected.quantity ? Math.max(0, (selected.baseTotal - selected.totalCents) / selected.quantity) : 0;
        payload = { ...payload, items: kit.getShippingItems().map(item => ({
          sku: item.sku || String(item.id),
          quantity: item.quantity,
          weightGrams: shipping.config.weightMode === 'default' ? shipping.config.fallbackWeightGrams : item.weight > 0 ? item.weight : shipping.config.fallbackWeightGrams,
          ...shipping.config.dimensions,
          unitPriceCents: Math.max(0, Math.round(item.price - discountPerPiece))
        })) };
      }
      return originalRequest(path, payload, controller);
    };
    shipping.invalidate();
    shipping.renderPromotion();
  };
  document.addEventListener('wnc:kit-change', event => {
    const kit = event.target.closest('wnc-product-kit');
    const shipping = kit?.querySelector('wnc-shipping-calculator');
    if (shipping?.wncKitBridge) {
      shipping.invalidate();
      shipping.renderPromotion();
    } else attach(kit);
  });
  document.querySelectorAll('wnc-product-kit').forEach(attach);
})();

